import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import injectRole from '../../components/HOC/injectRole'
import { TRoles, TRoutes } from '../../shared/const'

import Changelog from '../../components/views/admin/Changelog'

/**
 * Entwicklungen und Auslieferungen — nur für die Administration.
 *
 * Die Liste dient als Beilage zur Abrechnung und gehört damit zwischen
 * Junior Achievement und die Entwicklung, nicht in die Schulen.
 */
function ChangelogPage(props) {
	if ([TRoles.ADMIN, TRoles.FEDERAL_ADMIN].includes(props.role)) return <Changelog />

	return <Redirect to={TRoutes.DASHBOARD} />
}

ChangelogPage.propTypes = {
	role: PropTypes.string.isRequired
}

export default injectRole(ChangelogPage)
